export default [
  {
    path: '/admin/lucky-draw-items',
    name: 'lucky-draw-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/lucky-draw/lucky-draw-item/index.vue')
  }
]